<template>
    <lazy-loaded-image
        class="pc-program-logo"
        v-bind:src="programLogoUrl"
        v-bind:placeholder-height="60" />
</template>

<script>
    import lazyLoadedImage from "./lazyLoadedImage.vue";

    export default {
        components: {
            lazyLoadedImage
        },
        props: {
            agencyImgId: { type: String, required: false, default: null }
        },
        computed: {
            programLogoUrl() {
                const imgId = this.agencyImgId ?? this.$app.ProgramInfo.AgencyImgId;
                return `${this.$app.AgencyLogoUrl}/${imgId}`;
            }
        }
    };
</script>

<style lang="scss">
    @import "./_nav-style-vars.scss";

    .pc-program-logo {
        background-size: 100% 100%;
        max-width: $pc-nav-program-logo-max-width;
        max-height: $pc-nav-progam-logo-max-height;
    }
</style>
